import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';
import ErrorPage from '../modules/error/ErrorPage';

const CategorySection = lazy(() => import('../modules/settings/categories/CategorySection'));

const CategoryRoutes = (
  <>
    <Route
      path="categories"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <CategorySection />
        </Suspense>
      }
    />
  </>
);

export default CategoryRoutes;
